import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { LlPermissionsService } from '../ll-permissions.service';
import { LlExamService } from '../ll-exam.service';

@Component({
  selector: 'll-exam-sections-receivables',
  templateUrl: './ll-exam-sections-receivables.component.html',
  styleUrl: './ll-exam-sections-receivables.component.css'
})
export class LlExamSectionsReceivablesComponent {


  @ViewChild('mainDiv_ll_exam_sections_receivables') mainDiv!: ElementRef;
  @ViewChild('descriptionEditor') descriptionEditor!: ElementRef;

  bundle = {
    showPanel: false,
    mode: '',
    function: '',
    parentW: 0,
    parentH: 0,
    panelX: 0,
    panelY: 20,
    panelW: 0,
    panelH: 0,
    questionList: [] as any[],
    modalQuestion: null as any,
  };

  // Contact Modal
  showContactModal = false;
  contactChange = false;
  modalTitle = '';
  showAddContactModal = false;



  // Description Editor Modal
  showDescriptionModal = false;
  editingDescriptionQuestion: any = null;
  originalDescriptionHtml = '';
  descriptionHasChanged = false;


  constructor(
    private LlPermissionsService: LlPermissionsService,
    private LlExamService: LlExamService,
  ) { }

  ngAfterViewInit() {
    this.setVars();
  }

  setVars() {
    this.bundle.showPanel = false;
    this.bundle.function = this.mainDiv.nativeElement.parentElement.id;
    this.bundle.parentW = this.mainDiv.nativeElement.parentElement.parentElement.clientWidth;
    this.bundle.parentH = this.mainDiv.nativeElement.parentElement.parentElement.clientHeight;

    setTimeout(() => {
      this.bundle.panelW = this.bundle.parentW;
      this.bundle.panelH = this.bundle.parentH - this.bundle.panelY - 50;
    });

    this.getData();
  }

  getData() {
    this.LlExamService.NG_LL_model_exam_section_receivables_get((arr: any[]) => {


      console.log(arr)

      this.bundle.questionList = arr || [];
      this.bundle.showPanel = true;

    });
  }





  // ==================== DESCRIPTION EDITOR ====================
  openDescriptionEditor(q: any) {
    this.editingDescriptionQuestion = q;
    this.originalDescriptionHtml = q.PROSPECT_COMPANY_DESC_HTML || '';
    this.descriptionHasChanged = false;
    this.showDescriptionModal = true;

    setTimeout(() => {
      if (this.descriptionEditor?.nativeElement) {
        this.descriptionEditor.nativeElement.innerHTML = this.originalDescriptionHtml;
      }
    }, 100);
  }

  onDescriptionChange() {
    this.descriptionHasChanged = true;
  }

  saveDescriptionChanges() {
    if (!this.editingDescriptionQuestion || !this.descriptionEditor?.nativeElement) return;
    const newHtml = this.descriptionEditor.nativeElement.innerHTML.trim();
    this.editingDescriptionQuestion.PROSPECT_COMPANY_DESC_HTML = newHtml;
    this.LlExamService.NG_LL_model_exam_section_scope_edit(
      () => { this.getData(); },
      'PROSPECT_COMPANY_DESC_HTML',
      newHtml
    );
    this.closeDescriptionModal();
  }

  closeDescriptionModal() {
    this.showDescriptionModal = false;
    this.editingDescriptionQuestion = null;
    this.descriptionHasChanged = false;
  }



  onChanged(fieldName: string, newValue: string, studyQuestionId: number): void {
    this.setQuestionValue(fieldName, newValue, studyQuestionId);
  }

  setQuestionValue(fieldName: string, value: string, studyQuestionId: number): void {
    const question = this.bundle.questionList.find(q => q.STUDYQUESTIONID === studyQuestionId);
    if (question) question[fieldName] = value;
  }

  saveQuestion(studyQuestionId: number): void { }
}
